module.exports = __webpack_public_path__ + "static/media/stemedu2.d6ef8adf.webp";